import { ResourceError } from "@features/errors";

import {
  usePurchaseOrderQuery,
  usePurchaseOrderVariantsListQuery,
} from "../data";
import { PurchaseOrderContext } from "./PurchaseOrderContext";
import { PurchaseOrderSkeleton } from "./PurchaseOrderSkeleton";

const PurchaseOrderProvider = ({
  purchaseOrderId,
  children,
}: {
  purchaseOrderId: string;
  children: React.ReactNode;
}) => {
  const poQuery = usePurchaseOrderQuery(purchaseOrderId);
  const povQuery = usePurchaseOrderVariantsListQuery(purchaseOrderId);

  if (poQuery.error || povQuery.error) {
    return <ResourceError error={poQuery.error || povQuery.error} />;
  }

  if (poQuery.isPending) {
    return <PurchaseOrderSkeleton />;
  }

  return (
    <PurchaseOrderContext.Provider
      value={{
        purchaseOrder: poQuery.data,
        purchaseOrderVariants: povQuery.data ?? [],
        poQuery,
        povQuery,
      }}
    >
      {children}
    </PurchaseOrderContext.Provider>
  );
};

export default PurchaseOrderProvider;
